import * as R from 'ramda';

import type { AnyObject } from '../types/AnyObject';

export const createWhereVariablesGetter =
    <T>({
        searchStringFields,
        filtersToWhere,
        customSearchStringFieldCreators,
    }: {
        searchStringFields: string[];
        filtersToWhere?: (rest: any[]) => any[];
        customSearchStringFieldCreators?: Record<string, (fieldName: string) => AnyObject>;
    }) =>
    (selectedFilters: { [key: string]: boolean[] | string[] } & { searchString: string }): T | undefined => {
        const { searchString, ...rest } = selectedFilters || {};
        const restOnlyWithValue = Object.entries(rest).filter(([, value]) => value.length && !R.isNil(value));

        const whereVariables = filtersToWhere?.(restOnlyWithValue);

        const filtersWhere = whereVariables?.length
            ? {
                  and: whereVariables,
              }
            : undefined;

        const stringWhere = searchString && {
            or: searchStringFields.map((fieldName) =>
                customSearchStringFieldCreators?.[fieldName]
                    ? {
                          [fieldName]: customSearchStringFieldCreators[fieldName](searchString),
                      }
                    : {
                          [fieldName]: {
                              containsi: searchString,
                          },
                      },
            ),
        };

        if (stringWhere && filtersWhere && !R.isEmpty(filtersWhere)) {
            return {
                and: [stringWhere, filtersWhere],
            } as T;
        }

        if (stringWhere) {
            return stringWhere as T;
        }

        if (!R.isEmpty(filtersWhere)) {
            return filtersWhere as T;
        }

        return undefined;
    };
